module.exports = __webpack_public_path__ + "static/img/beaches.a394086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beaches.jpg
// module id = 25
// module chunks = 1